import { useLocation, useNavigate } from "react-router-dom";
import AdminNav from "../../Components/AdminNav/AdminNav";
import AdminHeader from "../../Components/AdminHeader/AdminHeader";
import React, { useState } from "react";
import { addDocument } from '../../actions/Documents'; // Adjust the import path as needed

function AddDocument() {
    const location = useLocation();
    const navigate = useNavigate();
    const user = location.state?.user;
    const [isCollapsed, setIsCollapsed] = useState(true);
    const [title, setTitle] = useState('');
    const [pdfFile, setPdfFile] = useState<File | null>(null);
    const [isSubmitting, setIsSubmitting] = useState(false);

    function handleFileChange(e: React.ChangeEvent<HTMLInputElement>) {
        if (e.target.files && e.target.files[0]) {
            const file = e.target.files[0];
            if (file.type === 'application/pdf') {
                setPdfFile(file);
            } else {
                alert('Please upload a PDF file');
                e.target.value = ''; // Reset input
            }
        }
    }

    async function handleSubmit(e: React.FormEvent) {
        e.preventDefault();
        if (!pdfFile || !user?.id) {
            alert('Please select a PDF file and ensure you are logged in');
            return;
        }

        setIsSubmitting(true);

        try {
            const response = await addDocument({
                title,
                document: pdfFile,
                userId: user.id
            });

            if (response.data.success) {
                alert('Document uploaded successfully');
                // Clear form
                setTitle('');
                setPdfFile(null);
                // Navigate to documents list
                navigate('/dashboard/documents/list', {
                    state: { user }
                });
            } else {
                alert(response.data.message || 'Error uploading document');
            }
        } catch (error) {
            console.error('Error:', error);
            alert('Error uploading document. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    }

    return (
        <div>
            <AdminHeader isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} user={user}/>
            <AdminNav collapsed={isCollapsed} setCollapsed={setIsCollapsed} user={user} />

            <div className={`main-admin-page ${isCollapsed ? 'collapsed' : 'expanded'}`}>
                <div className='main-admin-page-inner'>
                    <form onSubmit={handleSubmit}>
                        <h2>Add New Document</h2>

                        <div className="content-form-field">
                            <input
                                type="text"
                                className="input-email"
                                placeholder="Title"
                                value={title}
                                onChange={(e) => setTitle(e.target.value)}
                                required
                            />
                        </div>

                        <div className="content-form-field" style={{ marginTop: '10px', marginBottom: '10px' }}>
                            <input
                                type="file"
                                accept=".pdf"
                                onChange={handleFileChange}
                                required
                            />
                            {pdfFile && (
                                <p className="file-name">Selected file: {pdfFile.name}</p>
                            )}
                        </div>

                        <div className="content-form-button">
                            <button type="submit" disabled={isSubmitting || !pdfFile}>
                                {isSubmitting ? 'Submitting...' : 'Save Changes'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default AddDocument;
